import { usePropertyViewCount } from "../../../propertyDetail/hooks/usePropertyViewCount";
import { DashboardLayout } from "../../../../../layouts/DashboardLayout";
import { PrivatePropertyDetailWrapper } from "./PrivatePropertyDetailWrapper";
import React from "react";

interface PrivatePropertyDetailsPropInterface {
  propertyData: any;
}

export const PrivatePropertyDetails: React.FC<
  PrivatePropertyDetailsPropInterface
> = ({ propertyData }) => {
  usePropertyViewCount({ property: propertyData });
  return (
    <DashboardLayout>
      <PrivatePropertyDetailWrapper
        propertyData={propertyData}
        propertyType="private_property"
      />
    </DashboardLayout>
  );
};
